import React, { useMemo, useState } from "react";
import { DataGrid } from "@material-ui/data-grid";
import moment from "moment";
import { SensorSettingsMenu } from "./SensorSettingsMenu.jsx";
import UpdateDisplayName from "./UpdateDisplayName.jsx";
import smartParkService from "../../../axios";
import { useSelector } from "react-redux";
import { login_ } from "../../../reducers/login.js";
import _ from "lodash";
import SensorAssignActionBtn from "./ActionBtn.jsx";
import { Grid } from "@material-ui/core";
import { useLocation, useHistory } from "react-router-dom";
const formatLastReportedOn = (value) => {
  if (!value) {
    return "N/A";
  }

  return moment(new Date(value)).format("MM/DD/YYYY hh:mm A");
};

export const SensorConfigGrid = ({
  rows = [],
  refreshHandler,
  selectedFacility,
}) => {
  const location = useLocation();
  const history = useHistory();
  const loginDetails = useSelector(login_);
  const userid = _.get(loginDetails, ["UserID"], "");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const initialModalDetails = {
    label: null,
    action: null,
    open: false,
    row: null,
    value: null,
  };
  const [modalDetails, setModalDetails] = useState(initialModalDetails);
  const menuItemHandler = ({ option, row }) => {
    if (option.value === "details") {
      const params = new URLSearchParams(location.search);
      const facility = params.get("facility");
      history.push(`/SensorDetails?facility=${facility}&sensorId=${row.id}`);
    }
    if (option.value === "rename") {
      setModalDetails((prev) => ({
        ...prev,
        open: true,
        action: option.value,
        row: row,
        value: row.sensor_display_name || row.id,
      }));
    }
    if (option.value === "assign") {
      const action = row.facility_id ? "unassign" : "assign";
      setModalDetails((prev) => ({
        ...prev,
        label: action === "unassign" ? "Assigned Facility" : "Assign To:",
        label: action === "unassign" ? "Assigned Facility" : "Assign To:",
        open: true,
        action: action,
        row: row,
        value:
          row.facility_name ||
          row.facility_id ||
          selectedFacility ||
          "Unassigned",
        value:
          row.facility_name ||
          row.facility_id ||
          selectedFacility ||
          "Unassigned",
      }));
    }
    if (option.value === "bulkassign" || option.value === "bulkunassign") {
      setModalDetails((prev) => ({
        ...prev,
        label:
          option.value === "bulkassign" ? "Assigned Facility" : "Assign To:",
        label:
          option.value === "bulkassign" ? "Assigned Facility" : "Assign To:",
        open: true,
        action: option.value,
        row: selectedRows,
        value: selectedRows.map((item) => item.id),
      }));
    }
  };

  const saveButtonHandler = async () => {
    const { action, value, row } = modalDetails;
    const params = new URLSearchParams(location.search);
    const facility = params.get("facility");
    let payload = {};
    let url;
    setLoading(true);
    if (action === "rename") {
      url = "api/configuration/sensor/updateDisplayName";
      payload = {
        SensorID: row.id,
        SensorType: "VXDotSensor",
        DisplayName: value,
      };
    }
    if (action === "assign") {
      url = "api/configuration/sensor/assign";
      payload = {
        FacilityID: facility,
        SensorType: "VXDotSensor",
        AssignmentID: facility,
        AssignmentName: null,
        AssignmentGroupName: null,
        SensorList: [row.id],
      };
    }
    if (action === "bulkassign") {
      url = "api/configuration/sensor/assign";
      payload = {
        FacilityID: facility,
        SensorType: "VXDotSensor",
        AssignmentID: facility,
        AssignmentName: null,
        AssignmentGroupName: null,
        SensorList: value,
      };
    }
    if (action === "unassign") {
      url = "api/configuration/sensor/unassign";
      payload = {
        FacilityID: facility,
        SensorList: [row.id],
        TileAction: "none",
      };
    }
    if (action === "bulkunassign") {
      url = "api/configuration/sensor/unassign";
      payload = {
        FacilityID: facility,
        SensorList: value,
        TileAction: "none",
      };
    }

    try {
      const res = await smartParkService.post(url, payload, {
        headers: {
          "x-access-token": "citizen",
          userid: userid,
        },
      });
      if (res.status === 200) {
        if (res?.data) {
          alert(res?.data?.message);
        }
        refreshHandler();
      }
    } catch (err) {
      console.error("Failed to update display name:", err);
    } finally {
      setLoading(false);
      setModalDetails(initialModalDetails);
    }
  };
  const columns = useMemo(
    () => [
      { field: "name", headerName: "Sensor Name", flex: 1, minWidth: 180 },
      { field: "id", headerName: "Sensor ID", flex: 1, minWidth: 220 },
      {
        field: "sensor_display_name",
        headerName: "Display Name",
        flex: 1,
        minWidth: 180,
        valueFormatter: ({ value }) => value || "N/A",
      },
      {
        field: "facility_name",
        headerName: "Facility",
        flex: 1,
        minWidth: 180,
        valueFormatter: ({ value }) => value || "Unassigned",
      },
      {
        field: "last_reported_on",
        headerName: "Last Reported",
        flex: 1,
        minWidth: 190,
        valueFormatter: ({ value }) => formatLastReportedOn(value),
      },
      {
        field: "settings",
        headerName: "Settings",
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params) => {
          const { row } = params;
          return (
            <SensorSettingsMenu
              row={row}
              menuItemHandler={(opt, row) =>
                menuItemHandler({ option: opt, row })
              }
            />
          );
        },
      },
    ],
    [],
  );

  const gridRows = useMemo(
    () =>
      rows.map((row) => ({
        ...row,
        settings: row.id,
      })),
    [rows],
  );

  const handleSelectionChange = (selection) => {
    const selectedRows = rows.filter((row) => selection.includes(row.id));
    setSelectedRows(selectedRows);
  };

  return (
    <div style={{ width: "100%" }}>
      <UpdateDisplayName
        label={modalDetails.label}
        action={modalDetails.action}
        open={modalDetails.open}
        row={modalDetails.row}
        value={modalDetails.value}
        onChange={(e) => setModalDetails((prev) => ({ ...prev, value: e }))}
        onClose={() => {
          setModalDetails(initialModalDetails);
        }}
        onSave={saveButtonHandler}
        loading={loading}
      />
      <Grid container spacing={2}>
        <Grid item xs={9}></Grid>
        <Grid item xs={3}>
          <SensorAssignActionBtn
            labels={[
              { name: "Bulk Assign", action: "bulkassign", color: "primary" },
              {
                name: "Bulk Unassign",
                action: "bulkunassign",
                color: "default",
              },
            ]}
            selectedData={selectedRows}
            buttonHandler={(info) =>
              menuItemHandler({ option: info, row: selectedRows })
            }
          />
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            rows={gridRows}
            checkboxSelection
            onSelectionModelChange={handleSelectionChange}
            columns={columns}
            hideFooter={gridRows.length <= 100}
            autoHeight
            disableSelectionOnClick
            pageSize={100}
            disableColumnMenu
            disableColumnMenu
          />
        </Grid>
      </Grid>
    </div>
  );
};
